<!--https://v3.ru.vuejs.org/ru/guide/migration/v-model.html#%D0%B0%D1%80%D0%B3%D1%83%D0%BC%D0%B5%D0%BD%D1%82%D1%8B-v-model-->
<!--https://chrysanthos.xyz/article/how-to-get-the-data-of-a-proxy-object-in-vue-js-3/-->

<template>
  <section class="section-form" ref="rootContainer">

    <ProgressDialog
        :visible="ProgressDialogVisible"
        :value="ProgressDialogValue"
        :cancelUploadFlag="ProgressDialogCancelValue"
        @cancel-upload="progressDialogCancelUploadMethod"
        :currentFileName="currentFileNameForProgressDialog"
    >
      <!--        :cancelUploadMethod="progressDialogCancelUploadMethod"-->


    </ProgressDialog>

    <div id="form-section" class="flex-grid form-grid">
      <div class="container">
      <div class="forms-tabs">
        <div class="form-title">Submit Ticket</div>
        <div class="swiper-container swiper-tabs">

          <ul
              class="swiper-wrapper tabs-ul tabs-3"
              :class="countHeaders"
              style="display: none"
          >

            <li v-if="!loading">Loading</li>
<!--            <li-->
<!--                v-else-->
<!--                v-for="item in menu_headers"-->
<!--                :key="item.id"-->
<!--                class="swiper-slide tab-link"-->
<!--                :data-tab="'tab-' + item.sort"-->
<!--                :data-hash="item.hash"-->
<!--                :class="{current: activeForm === item.hash}"-->
<!--            >{{ item.label }}-->
<!--            </li>-->
            <!--                @click="menuItemClick(item.hash, $event)"-->


            <li class="mark"></li>
          </ul>

        </div>


        <div class="tab-container-wrap">
          <div id="tab=1" class="tab-container current">
            <div class="form-main">
              <form id="download_form" action="#" method="post" autocomplete="off" style="display: block;" v-show="!thankYouBlockShow">

                <div
                    class="input-field"
                    :class="{ 'field-error': firstnameError }"
                >
                  <input
                      id="download_firstname"
                      name="firstname"
                      type="text"
                      required="required"
                      class="input"
                      v-model="firstname"
                  >

                  <span
                      v-if="firstnameError"
                      v-html="firstnameErrorMessage"
                      class="error"
                  ></span>

                  <label for="download_firstname" class="label">First Name</label>
                </div>


                <div
                    class="input-field"
                    :class="{ 'field-error': lastnameError }"
                >
                  <input
                      id="download_lastname"
                      type="text"
                      required="required"
                      class="input"
                      v-model="lastname"
                  >

                  <span
                      v-if="lastnameError"
                      v-html="lastnameErrorMessage"
                      class="error"
                  ></span>

                  <label for="download_lastname" class="label">Last Name</label></div>


                <div
                    class="input-field"
                    :class="{ 'field-error': emailError }"
                >
                  <input
                      id="download_email"
                      type="text"
                      required="required"
                      class="input"
                      v-model="email"
                  >
                  <span v-if="emailError" v-html="emailErrorMessage" class="error"></span>
                  <label for="download_email" class="label">Corporate Email</label>
                </div>

                <div
                    class="input-field"
                    :class="{ 'field-error': phoneError }"
                >
                  <div>
                    <input
                        id="download_phone"
                        type="tel"
                        required="required"
                        class="input"
                        v-model="phone"
                        ref="phoneRef"
                    >
                    <label for="download_phone" class="label">Phone Number</label>
                    <span v-html="phoneErrorMessage" class="error"></span>
                  </div>
                </div>

                <div class="input-check-field">
                  <div
                      class="radio-field"
                      :class="{ 'field-error': firstnameError }"
                  >
                    <input
                        id="check_create_ticket"
                        name="ticket"
                        v-model="ticket_type"
                        value="new"
                        type="radio"
                        required="required"
                        class="input"
                        checked
                    >

                    <label for="check_create_ticket" class="radio-label">Create new ticket</label>
                  </div>
                  
                  <div
                      class="radio-field"
                      :class="{ 'field-error': firstnameError }"
                  >
                    <input
                        id="check_existing_ticket"
                        name="ticket"
                        v-model="ticket_type"
                        value="update"
                        type="radio"
                        required="required"
                        class="input"
                    >

                    <label for="check_existing_ticket" class="radio-label">Update existing ticket</label>
                  </div>                  
                  
                </div>

                <div
                    class="input-field"
                    :class="{ 'field-error': existingTicketNumberError }"
                    v-show="ticket_type === 'update'"
                >
                  <input
                      id="existing_ticket_number"
                      type="text"
                      required="required"
                      class="input"
                      v-model="existing_ticket_number"
                  >

                  <span v-if="existingTicketNumberError" v-html="existingTicketNumberErrorMessage" class="error"></span>

                  <label
                      for="existing_ticket_number"
                      class="label"
                  >
                    Existing ticket number
                  </label>
                </div>

                  <div class="input-field select" id="download_product_wrapper" v-show="ticket_type === 'new'">
                    <select
                        id="download_product"
                        class="select-text vue vue-2023"
                        v-model="product"
                        ref="productRef"
                    >
                    </select>
                    <div class="select-label">Case Reason</div>
                  </div>

                

                <div
                    class="input-field"
                    :class="{ 'field-error': subjectError }"
                >
                  <input
                      id="download_title"
                      type="text"
                      required="required"
                      class="input"
                      v-model="subject"
                  >

                  <span v-if="subjectError" v-html="subjectErrorMessage" class="error"></span>

                  <label
                      for="download_title"
                      class="label"
                  >
                    Subject
                  </label>
                </div>

                <!-- Files -->
                <DropZone @files-dropped="filesDropped"/>

<!--                <template v-if="storageMultipleFile.length > 0">-->
<!--                  <template v-for="item in storageMultipleFile" :key="item.index">-->
<!--                    <FileField-->
<!--                        :customData="{-->
<!--                          index: item.index,-->
<!--                          allowedExtension: ['iso', 'pdf', 'zip', 'log', 'txt', 'jpg', 'png', '7z', 'gz'],-->
<!--                        }"-->
<!--                        @destroy="destroyFileField"-->
<!--                        @created="createdFileField"-->
<!--                        @validate="validateFileField"-->
<!--                    />-->
<!--                  </template>-->
<!--                </template>-->

<!--                <div class="input-field select" id="download_product_wrapper">-->
<!--                  <button @click="incStorageMultipleFileCounter($event)" class="add-file-field-button">Add one more file</button>-->
<!--                </div>-->

                <div class="input-field">
                  <textarea id="comments" class="textarea" v-model="comments" required></textarea>
                  <label for="comments" class="label">Description (optional)</label>
                </div>

                <div
                    class="input-field" id="captchaDraw"
                    :class="{ 'field-error': captchaError }"
                >
                  <div class="input-group">
                    <div v-html="captchaDraw" class="captcha-image"></div>
                    <div class="captcha-input input-field">
                      <input
                          id="input_captcha"
                          type="text"
                          required
                          class="input"
                          v-model="captchaValue"
                      >
                      <label data-v-3445a218="" for="input_captcha" class="label">Antispam-code</label>
                      <span v-html="captchaErrorMessage" class="error"></span>
                    </div>
                </div>
                </div>

                <div class="checkbox-wrap">
                  <div class="checkbox" v-show="isEuroZone">
                    <label id="download_checkmark" for="download_check_me">
                      <input type="checkbox" id="download_check_me" required="required" v-model="check_me">
                      <div class="checkbox-main">
                        <span class="check"></span>
                      </div>
                      <span class="checkbox-text">


                              I agree with the <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">Privacy Policy</a> and allow the use of the provided information for communication purposes.
                              I understand that I can withdraw my consent at any time by submitting the request to <a href="mailto:dataprotection@starwind.com">dataprotection@starwind.com</a>.

                              <span class="error-checkbox" v-if="privacyPolicyError">
                              Please confirm that you have read and accepted the Privacy Policy before proceeding
                              </span>
                          </span>

                    </label>
                  </div>

                  <div class="checkbox" v-show="!isEuroZone">
                    <label id="download_checkmark" for="download_check_me">
                            <span class="checkbox-main">
                                By submitting, you are agreeing to have your personal information managed
                                in accordance with the terms of StarWind Software Inc
                                <a href="https://www.starwindsoftware.com/privacy-policy" target="_blank">Privacy Policy</a>.
                            </span>
                    </label>
                  </div>

                </div>

                <div class="input-field btn-wrap">
                  <button type="submit" class="btn blue" @click="submitForm($event)">{{submitButtonLabel}}</button>
                </div>






              </form>
            </div>
          </div>
        </div>

        <!--            Thank you form block-->
        <div id="thank-you-form-block" class="thank-text"  v-show="thankYouBlockShow">
<!--          v-html="thankYouBlockContent"-->

<!--          <div class="message support-form-wrap">-->
            <h2 class="title">Thank you for submitting your request.</h2>

            <p class="text">
              You will receive an auto-reply with a case number that you can use as reference.
            </p>

            <p class="text">
              Our Customer Service Representatives will provide you with the additional information.
            </p>
<!--          </div>-->

        </div>


        <div class="overlay_loader">
          <div class="loader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>

      </div>
      </div>
    </div>


  </section>
</template>

<script>
// eslint-disable-next-line
// import { isProxy, toRaw } from 'vue';
import Choices from "choices.js";
import intlTelInput from "intl-tel-input";
// import europe_zone_country from "./libs/eurozone";
import europe_zone_country from "@/components/libs/eurozone";
import getLicense from "@/components/libs/getLicense";
// eslint-disable-next-line
import {useCookies} from "vue3-cookies";
// import ProgressBar from 'primevue/progressbar';
import ProgressDialog from "@/components/ProgressDialog.vue";
import DropZone from "@/components/fields/DropZone.vue";

// eslint-disable-next-line
import {ErrorMessages, filterErrors, sortErrors} from "@/components/libs/errors_function";
// eslint-disable-next-line
import {uploadLargeFile} from "@/components/libs/upload";
import {toRef} from "vue";
// eslint-disable-next-line
import {sendModel} from "@/components/libs/sendModel";

// eslint-disable-next-line
import FileField from "@/components/fields/FileField.vue";
// eslint-disable-next-line
import {uploadSequenceFiles, getCounter} from "@/components/libs/upload-v2";


// let globalConfig = {};
// let cancelStatusRef = null

export default {
  name: "App",
  components: {
    // ProgressBar,
    ProgressDialog,
    // eslint-disable-next-line
    FileField,
    DropZone,
  },
  setup() {
    const { cookies } = useCookies();
    return { cookies };
  },
  data() {
    return {

      // ProgressDialogVisible: true,
      ProgressDialogVisible: false,
      // ProgressDialogValue: 30,
      // ProgressDialogValue: null,
      ProgressDialogValue: 0,
      ProgressDialogCancelValue: false,
      sid: '',

      //configs
      cbs: {},
      // activeForm: 'quote',
      activeForm: 'support',
      loading: false,
      menu_headers: [],
      config: null,
      countryShow: false,
      configProducts: {},
      showSubProduct: false,
      subProductLabel: "",
      thankYouBlockContent: "",
      thankYouBlockShow: false,
      // config: null,

      // phoneShow: false,

      //data
      firstname: '',
      // firstname: 'An',
      lastname: '',
      // lastname: 'Koch',
      company: '',
      email: '',
      // email: 'ak@kobedu.com',
      // email: 'anatolii.kochurkov@starwind.com',
      country: '',
      title: '',
      phone: '',
      // phone: '+380501234567',
      // phone: '+310612345678',
      product: '',
      sub_product: '',
      comments: '',

      captchaDraw: '',
      encCaptchaValue: '',
      captchaValue: '',

      step: 1,

      subject: '',

      ticket_type: 'new', //or update
      existing_ticket_number: '',

      // subject: 'Subject Test',

      //additional flag
      check_me: false,

      // validVSANSubProduct: false,
      // validVSANFreeSubProduct: false,
      // validSANNASSubProduct: false,
      // valid_vHCI_subProduct: false,

      // products: [],
      // sub_products: [],

      detectedCountry: '',

      //refs
      countryRef: null,
      intlTelInputRef: null,
      productRef: null,
      subProductRef: null,
      fileUploadRef: null,

      //errors
      errors: {},
      privacyPolicyError: false,

      //
      fileErrorObject: null,

      storageMultipleFile: [], //multiple file storage
      storageMultipleFileCounter: 0, //1 - is minimum, always check
      currentFileNameForProgressDialog: '',
      cancelStatusRef: null,
    }
  },
  async created() {

    // console.log('storageMultipleFile', this.storageMultipleFile)

    //callbacks
    if(    window.main_form_config != null
        && typeof window.main_form_config === 'object'
        && window.main_form_config.callbacks != null ) {

      const main_form_cb = window.main_form_config.callbacks;

      if(typeof main_form_cb === 'object') {
        for(let key in main_form_cb){
          if(typeof main_form_cb[key] === 'function') {
            switch (key) {
              case 'mounted':
              case 'submitCb':
              case 'beforeSend':
              case 'successSend':
              case 'failureSend':
                this.cbs[key] = main_form_cb[key];
                break;
            }
          }
          else{

            if(Array.isArray(this.cbs['data'])) {
              this.cbs['data'].push(main_form_cb[key])
            }
            else{
              this.cbs['data'] = [];
              this.cbs['data'].push(main_form_cb[key]);
            }
          }
        }

        // console.log('this.cbs', this.cbs);

      }

    }

    //read config form json
    let fullConfigPath = '';
    // console.log('window.main_form_config', window.main_form_config);

    if (   window.main_form_config != null
        && typeof window.main_form_config === 'object'
        && window.main_form_config.configUrl != null) {
      fullConfigPath = window.main_form_config.configUrl;
    }
    else {
      return;
    }

    //read config from remote file
    const config = await this.getFormConfig(fullConfigPath);
    this.config = config;

    this.menu_headers = config.headers;

    // activeHeader
    if(Object.prototype.hasOwnProperty.call(config, "activeHeader")) {
      switch (config.activeHeader) {
        case 'demo':
        case 'download':
        case 'pricing':
        case 'quote':
          this.activeForm = config.activeHeader;
          break;
      }
    }

    this.loading = true;


  },
  watch: {
    activeForm(newForm) {

      this.thankYouBlockShow = false;

      this.setProductsList(newForm);

      this.setThankYouBlock(newForm);

      // this.getLicense();
    },
    product() {
      this.setSubProductList();

      // this.getLicense();
    },
    sub_product() {

      if( this.sub_product !== '') {
        delete(this.errors.product);
      }

    },
  },
  mounted() {

    // cancelStatusRef = toRef(this.$data, 'ProgressDialogCancelValue')
    // console.log('MOUNT this.cancelStatusRef', cancelStatusRef)
    // cancelStatusRef.value = true
    // console.log('MOUNT CHANGED this.cancelStatusRef', cancelStatusRef)


    this.fileUploadRef = this.$refs.fileUploadRef

    this.productRef = new Choices(this.$refs.productRef, {
      searchEnabled: false,
      searchChoices: false,
      shouldSort: false,
      itemSelectText: "",
      allowHTML: true,
    });

    this.subProductRef = new Choices(this.$refs.subProductRef, {
      searchEnabled: false,
      searchChoices: false,
      shouldSort: false,
      itemSelectText: "",
      allowHTML: true,
    });

    this.initFunction();

    if(this.cbs.mounted !== null && typeof this.cbs.mounted === 'function') {
      this.cbs.mounted(this);
    }

    //multifile
    // this.storageMultipleFile.push({item: this.$refs.fileUploadRef, index: -1});
    // this.incStorageMultipleFileCounter()

  },
  computed: {

    countHeaders() {
      return 'count-headers-' + this.menu_headers.length;
    },


    firstnameError() {
      const key = "firstname";
      return this.checkFieldError(key);
    },

    firstnameErrorMessage() {
      const key = "firstname";

      // console.log('this.generateErrorMessage(firatnME)', key, this.generateErrorMessage(key) )

      return this.generateErrorMessage(key);
    },

    lastnameError() {
      const key = "lastname";
      return this.checkFieldError(key);
    },

    lastnameErrorMessage() {
      const key = "lastname";
      return this.generateErrorMessage(key);
    },

    emailError() {
      const key = "email";
      return this.checkFieldError(key);
    },

    emailErrorMessage() {
      const key = "email";
      return this.generateErrorMessage(key);
    },

    subjectError() {
      const key = "subject";
      return this.checkFieldError(key);
    },

    subjectErrorMessage() {
      const key = "subject";
      return this.generateErrorMessage(key);
    },

    existingTicketNumberError() {
      const key = "existing_ticket_number";
      return this.checkFieldError(key);
    },

    existingTicketNumberErrorMessage() {
      const key = "existing_ticket_number";
      return this.generateErrorMessage(key);
    },

    titleError() {
      const key = "title";
      return this.checkFieldError(key);
    },

    titleErrorMessage() {
      const key = "title";
      return this.generateErrorMessage(key);
    },

    companyError() {
      const key = "company";
      return this.checkFieldError(key);
    },

    companyErrorMessage() {
      const key = "company";
      return this.generateErrorMessage(key);
    },

    countryError() {
      const key = "country";
      return this.checkFieldError(key);
    },

    countryErrorMessage() {
      const key = "country";
      return this.generateErrorMessage(key);
    },

    phoneError() {
      const key = "phone";
      return this.checkFieldError(key);
    },

    phoneErrorMessage() {
      const key = "phone";
      return this.generateErrorMessage(key);
    },

    captchaError() {
      const key = "captchaValue";
      return this.checkFieldError(key);
    },

    captchaErrorMessage() {
      const key = "captchaValue";
      return this.generateErrorMessage(key);
    },

    // VSANSubProductErrorClass() {
    VSANSubProductError() {
      const key = "product";
      return this.generateErrorMessage(key);
    },

    VSANSubProductErrorMessage() {
      const key = "product";
      return this.generateErrorMessage(key);
    },


    submitButtonLabel () {

      switch (this.activeForm) {
        case 'quote':
        case 'pricing':
          return 'Send me pricing';
        case 'demo':
          return 'Request demo';
        case 'download':
        case 'support':
          return 'Submit Ticket';
        default:
          return 'Download';
      }

    },
    isCommentsRequired () {

      switch (this.activeForm) {
        case 'quote':
        case 'pricing':
        case 'demo':
          return true;
      }

      return false;

    },
    isEuroZone() {

      if(europe_zone_country == null) {
        return true;
      }

      return europe_zone_country.includes(this.country);

    }

  },
  methods: {

    filesDropped(data) {
      console.log('filesDropped', data)

      // this.incStorageMultipleFileCounter()

      this.storageMultipleFile = []

      if(!data.length) {
        return
      }

      data.map(el => {
        this.storageMultipleFile.push({
          index: this.storageMultipleFileCounter,
          item: el.item,

          //addition fields
          tempFileName: null,
          realFileName: null,
          uploaded: false,
          valid: true,
        })

        this.storageMultipleFileCounter++
      })


    },

    validateFileField(data) {

      const {index, fileErrorObject} = data

      //устанавливаем валидность по типу файла
      this.storageMultipleFile.map((item) => {
        if(item.index === index) {
          item.valid = fileErrorObject.success
        }
        return item
      })

      // console.log('validateFileField', index, fileErrorObject, this.storageMultipleFile)

    },

    createdFileField(data) {

      //добавляю в накопитель данные об индексе и ссылке на элемент, который создался
      this.storageMultipleFile.map((item) => {
        if(item.index === data.index) {
          item.item = data.ref
        }
        return item
      })

    },
    destroyFileField(data) {

      //если индекс элемента = 0, то я его не удаляю
      if(data === 0)
        return

      //удаляю из накопителя данные об элементе, который пользователь решил удалить
      this.storageMultipleFile = this.storageMultipleFile.filter((item) => item.index !== data)

    },

    incStorageMultipleFileCounter(event) {

      //этот метод запускается при старте, чтобы вывести одно поле
      // поэтому делаю проверку на событие, которого при старте нет
      if(event !== undefined) {
        event.preventDefault()
      }

      //max 5 files
      // if(this.storageMultipleFile.length === 5 ) {
      //   return
      // }


      this.storageMultipleFile.push({
        item: null,
        index: this.storageMultipleFileCounter,

        //addition fields
        tempFileName: null,
        realFileName: null,
        uploaded: false,
        valid: true,
      })

      this.storageMultipleFileCounter++

    },

    progressDialogCancelUploadMethod() {

      // console.log('progressDialogCancelUploadMethod before', cancelStatusRef.value, cancelStatusRef)

      this.ProgressDialogCancelValue = true
      // cancelStatusRef.value = true

      // console.log('progressDialogCancelUploadMethod after', cancelStatusRef.value, cancelStatusRef)


      //можно скрыть диалоговое окно
      this.ProgressDialogVisible = false

      // console.log(
      //     'invoke progressDialogCancelUploadMethod',
      //     this.ProgressDialogCancelValue
      // )

    },

    // async getCookieDetail() {
    getCookieDetail() {

      // console.log('getCookieDetail');

      const cookieValue = this.cookies.get("lightenc");
      // const cookieValue = 'c4ed7d59bca48177c21d155c391b922261f9ecb48ee49bb3196c9c2c256ea08388b1d66a3f0ddf6b2533c19932d26ca400a19ff8cd139817954e2ecc7f69b8658f18dff35937062886e78b17116ec02d5a3848e263a386fd5070e5eaabc6909acdaf7bb17cb16841b59b063567fb0b984ba22850f69b200793f124ea027c780f76cceaead3d782a08595158b2935ef8d0c3b41806efd4a81f90afc29807e14c72558b0e6510fb7dd7cecf8c0ce468f43d28d42a09383f9425b8344d7d79786206d9c42b92a92e99782e4ad3445caa07b53f78a70274ed53731066d7a59ecc2700207d5d3fe0dd1ccd66ecdc8522667618e70d3b6307dcd65e20acc21a1e35fb9c6b1efa7d73ed3e18f188fe4110fec614a1f9b2896ddea4e229712d43f3f67b48e20d20ee910bf3977fad45a38a55c0baa05e3a9fcdf955a438fcbe98f13234937d45aa376c8074fd2a3f7b1a93ad8e9d01cb4ac49014a3b8ed339017c66002bca87d28c7663ef27dd574beda8158dac753decedee368e75b0bad78cde52c507ea7f0b95af546c8f3cda8745618c95e9ad3ae668cd52f7170a98157e911c5ecc781feccc42e603278c22d9798e0f60916dc57c45dc61a1f636ddd55a4550141caf45bfd8a53c737550bdca154b593fd8ae27181d230757cca7f605c5ad493f06cc741d964dc486447c541c33c93378a6';
      // console.log('cookieValue', cookieValue);
      //
      const formData = new URLSearchParams({ cookieName: cookieValue });
      //
      fetch(
          "https://www.starwindsoftware.com/cookie-detail.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: formData,
            // credentials: "same-origin",
          }
      )
      .then((data) => {
        return data.json();
      })
      .then((data) => {
        // console.log('data', data);
        // return data;

        if(data.status === null) {
          return;
        }

        if( (data.result === null) || (data.result === false)){
          return;
        }

        if( (data.type === null) || (data.type !== 'cookie-detail') ) {
          return;
        }



        if (data.result.firstname !== null) {
          this.firstname = data.result.firstname;
        }

        if (data.result.lastname !== null) {
          this.lastname = data.result.lastname;
        }

        if (data.result.email !== null) {
          this.email = data.result.email;
        }

        if (data.result.title !== null) {
          this.title = data.result.title;
        }

        if (data.result.company !== null) {
          this.company = data.result.company;
        }

        // if (data.result.country !== null) {
        //   const country = data.result.country;
          // const country = 'Poland';
          // this.countryRef.setChoiceByValue(country);
          // this.country = country;
        // }

        if ((data.result.phone !== null) && (data.result.phone !== undefined)) {

          // console.log('data.result.phone', data.result.phone);

          this.intlTelInputRef.setNumber(data.result.phone);

          let phone = data.result.phone;
          phone = phone.replace("+", ""); //убираем +

          this.intlTelInputRef.setNumber(phone); //set phone
          this.phone = phone; //set model phone

          const code = this.intlTelInputRef.getSelectedCountryData();

          if (code.dialCode !== "") {
            phone = phone.replace(code.dialCode, ""); //clean code in number
            this.phone = phone;
          }

        }

        // console.log('умничка');
        // console.log('моё ты солнышко');



      });


    },

    // eslint-disable-next-line
    validEmail(options) {

      // eslint-disable-next-line
      if (window.successFormSubmit === null) {
        return;
      }

      // eslint-disable-next-line
      if(typeof window.successFormSubmit !== 'function') {
        return;
      }

      const url = 'https://www.starwindsoftware.com/validemail.js';

      const opts = {
        method: 'POST',
        body: options.email
      };

      fetch(url, opts).then((data) => {
        return data.json();
      })
      .then((response) => {

        options.valid = response.emailStatus;
        options.user  = response.cid;

        // console.log('validEmail', response, options);

        window.successFormSubmit(options);

      });

    },

    generateErrorMessage(field) {
      if (this.errors[field] != null) {
        const rule = this.errors[field][0];
        return ErrorMessages[field][rule];
      }
      return "";
    },
    checkFieldError(field) {
      return this.errors[field] != null;
    },

    // eslint-disable-next-line
    checkErrors(res) {

      // eslint-disable-next-line
      const errors =  {
        length: 0
      };

      // console.log('checkErrors func: ', res);

      for(let key in res) {
        if( Object.prototype.hasOwnProperty.call(errors, res[key]['field']  ) ) {
          errors[res[key]['field']].push(res[key]['rule']);
        }
        else{
          errors[ res[key]['field'] ] = [ res[key]['rule'] ];
        }
        errors.length += 1;
      }

      const sortErr = sortErrors(errors);

      this.errors =  filterErrors(sortErr);

      // console.log('errors', this.errors);

    },
    checkRequest(data) {

      this.checkErrors(data);

    },

    // eslint-disable-next-line
    pointFormValidation(url, data, success, failure) {

      const params = new URLSearchParams();

      for(let key in data) {
        params.append(key, data[key]);
      }


      // eslint-disable-next-line
      const options = {
        method: `POST`,
        body: params
      };

      document.querySelector('body').classList.add('preloader');

      if(this.cbs.beforeSend !== null && typeof this.cbs.beforeSend === 'function') {
        // this.cbs.beforeSend(this);
        this.cbs.beforeSend(this, params);
      }

      fetch(url, options)
          .then((data) => {
            return data.json();
          })
          .then((data) => {

            //!!!close body was here!!!
            // document.querySelector('body').classList.remove('preloader');
            // console.log('remote data:', data);

            if((data.success !== null) && data.success) {
              // success('ok');
              success(data);

              if(this.cbs.successSend !== null && typeof this.cbs.successSend === 'function') {
                this.cbs.successSend(this, data);
              }

            }
            else {
              failure(data.data);

              if(this.cbs.failureSend !== null && typeof this.cbs.failureSend === 'function') {
                this.cbs.failureSend(this, data);
              }

            }


          })
          // eslint-disable-next-line
          .catch((error) => {
            // console.log('resp failure data:', error)
            // someErrorFunction(error);
          });



    },

    isValidPhone() {

      let result = false;
      let extension = '';
      let number = '';
      let phoneCountry = '';

      if(this.intlTelInputRef.isValidNumber()) {
        result = true;
        extension = this.intlTelInputRef.getExtension();

        //very interesting
        // number = this.intlTelInputRef.getNumber(intlTelInputUtils.numberFormat.E164);
        number = this.intlTelInputRef.getNumber(0)
        phoneCountry = this.intlTelInputRef.getSelectedCountryData().iso2
      }

      return {
        result,
        extension,
        number,
        phoneCountry
      };

    },

    setModel() {

      const model = {};

      //check phone
      const modelPhone = this.isValidPhone();
      // console.log('model Phone', modelPhone);
      const lic = this.getLicense();
      // console.log('model license', lic);

      model.license       = lic.license;
      model.product       = this.product;

      model.firstname     = this.firstname;
      model.lastname      = this.lastname;
      model.company       = this.company;
      model.email         = this.email;
      // model.country       = this.country;
      model.title         = this.title;
      model.comments      = this.comments ?? "";

      model.phone2        = modelPhone.number ?? '';
      model.phoneStandart = modelPhone.number ?? '';
      model.phoneVersion  = 'v2023';
      model.phoneExt      = modelPhone.extension ?? '';
      model.validPhone    = modelPhone.result;
      model.phoneCountry  = modelPhone.phoneCountry ?? '';

      model.url             = window.location.href;
      model.formType        = 'support'
      model.subject         = this.subject
      model.captchaValue    = this.captchaValue
      model.encCaptchaValue = this.encCaptchaValue
      model.step            = this.step
      model.sid = this.sid
      model.PHPSESSID = this.sid

      model.zone = this.intlTelInputRef.getSelectedCountryData().iso2
      model.country = this.intlTelInputRef.getSelectedCountryData().name
      // console.log('zone', this.intlTelInputRef.getSelectedCountryData().iso2 )

      if( this.ticket_type === 'update' ) {
        model.existing_ticket_number = this.existing_ticket_number
      }

      model.Scenario_202306 = lic.Scenario_202306 ?? '';

      switch (model.product) {
        case 'StarWind NVMe-oF Initiator Trial':
        case 'StarWind NVMe-oF Initiator':
          if(this.sub_product.trim() !== '') {
            model.nvme_hosts = this.sub_product;
          }
      }

      // console.log('-' + this.sub_product.trim() + '-');

      // model.validVSANSubProduct = this.sub_product.trim() !== '';

      model.validVSANSubProduct     = lic.validVSANSubProduct;
      model.validVSANFreeSubProduct = lic.validVSANFreeSubProduct;
      model.validSANNASSubProduct   = lic.validSANNASSubProduct;
      model.valid_vHCI_subProduct   = lic.valid_vHCI_subProduct;





      // return model;
      return {
        model: model,
        url: lic.url
      }


    },

    //валидация: если хотя бы один файл не трушный, то и не пускаем процес дальше
    validateFiles() {
      return this.storageMultipleFile.reduce((acc, el) => el.valid && acc, true)
    },

    async uploadFiles () {

      //сбрасываес флаг отмены на загрузку при следующей попытке
      this.ProgressDialogCancelValue = false

      // const cancelStatus = toRef(this.$data, 'ProgressDialogCancelValue')
      // const cancelStatus = cancelStatusRef
      // const cancelStatus = this.cancelStatusRef


      const counter = await getCounter({url: 'https://www.starwindsoftware.com/point-form-validation.js'})

      // return;

      return await uploadSequenceFiles({
        storage: this.storageMultipleFile,
        // cancelStatus: cancelStatus,
        cancelStatus: toRef(this.$data, 'ProgressDialogCancelValue'),
        // cancelStatus: this.ProgressDialogCancelValue,
        ProgressDialogVisible: toRef(this.$data, 'ProgressDialogVisible'),
        ProgressDialogValue: toRef(this.$data, 'ProgressDialogValue'),
        currentFileNameForProgressDialog: toRef(this.$data, 'currentFileNameForProgressDialog'),
        // ProgressDialogVisible: this.ProgressDialogVisible,
        url: 'https://www.starwindsoftware.com/point-form-validation.js',
        zipFilename: counter.filename,
        callbacks: {
          //калбек для того, чтобы показать процент загрузки файла (срабатывает когда загрузился один из чанков)
          uploadChunkCallback: (params) => {

            // console.log('uploadChunkCallback', params)

            const {ProgressDialogValue, chunkIndex, totalChunks} = params

            if (totalChunks !== 0) {
              ProgressDialogValue.value = Math.trunc(chunkIndex * 100 / totalChunks )
            }

          },
          //срабатывает перед загрузкой нового файла из списка (обнуляет прогресс загрузки)
          beforeUploadFileCallback: (params) => {

            const {element} = params
            const {uName} = params
            const {ProgressDialogValue} = params

            //перед началом отправки обнуляю ПрогрессБар
            ProgressDialogValue.value = 0

            element.tempFileName = uName.filename

            // console.log('beforeUploadFileCallback storage', this.storageMultipleFile)
            // console.log('beforeUploadFileCallback ProgressDialogVisible', ProgressDialogVisible)

          },
          // (срабатывает когда файл загружен) (прогресс линию доводит до 100)
          uploadFileCallback: (params) => {

            const {element, ProgressDialogValue, cancelStatus} = params

            //после заливки файла ставлю 100 заливку
            ProgressDialogValue.value = 100

            if( !cancelStatus.value ) {
              element.uploaded = true
            }

            // console.log('after UploadFileCallback storage', this.storageMultipleFile)

          },
          //срабатывает когда загружено все
          uploadStorageCallback: (params) => {
            console.log('uploadStorageCallback', params)
          },
        },
      })


      // console.log('after upload', this.storageMultipleFile)

    },

    async submitForm(e) {

      e.preventDefault();

      if(this.cbs.submitCb !== null && typeof this.cbs.submitCb === 'function') {
        this.cbs.submitCb(this);
      }


      this.privacyPolicyError = false;
      if(this.isEuroZone && !this.check_me) {
        this.privacyPolicyError = true;
        return;
      }

      this.errors = {};

      //проверка файлов на валидность
      //но она странная, так как теперь невалидные файлы не добавляются в список заливки
      // if(this.validateFiles()) {
      //
      //   const result = await this.uploadFiles()
      //   console.log('uploadFiles', result)
      //   //{success: true, step: 3, zip: '418_66a790661e66a_dot_20240729.zip', message: 'support-file-upload'}
      // }
      //
      // return



      //check type file
      // if(this.fileError) {
      //   return
      // }

      // const model = this.setModel();
      const {url, model} = this.setModel();

      // console.log('activeForm', this.activeForm)

      // console.log('model', model);
      // console.log('ok send data');

      // eslint-disable-next-line
      const success = async (data) => {

        let resultUploadFiles = null
        let zipFileName = ''


        // if(this.validateFiles()) {
        //
        //   const result = await this.uploadFiles()
        //   console.log('uploadFiles', result)
        //   //{success: true, step: 3, zip: '418_66a790661e66a_dot_20240729.zip', message: 'support-file-upload'}
        // }

        if(this.validateFiles()) {
          resultUploadFiles = await this.uploadFiles()
          // console.log('uploadFiles', result)
          //{success: true, step: 3, zip: '418_66a790661e66a_dot_20240729.zip', message: 'support-file-upload'}
        } else {
          return
        }

        if( resultUploadFiles !== null && typeof resultUploadFiles === 'object' && resultUploadFiles.success ) {
          zipFileName = resultUploadFiles.zip
        }

        model.filename = zipFileName


        // console.log('sendModel', model)
        // временно отключил
        const result = await sendModel('https://www.starwindsoftware.com/point-form-validation.js', model)
        document.querySelector('body').classList.remove('preloader');
        console.log('last', result)

        //временно отключил
        this.thankYouBlockShow = true

        this.$refs.rootContainer.scrollIntoView(true)

        //scroll variant
        //https://stackoverflow.com/questions/15521081/pure-js-equivalent-of-jquery-animate

        // https://accreditly.io/articles/create-a-chunked-uploader-in-js-and-php-to-handle-large-files


      }

      const failure = (data) => {

        // console.log('failure func', data);
        this.checkRequest(data);
        document.querySelector('body').classList.remove('preloader');

      };


      this.pointFormValidation(url, model, success, failure);




    },

    getLicense() {
      return getLicense(this.activeForm, this.product, this.sub_product);
    },

    setSubProductList() {

      //очистить список sub продуктов
      // this.subProductRef.clearStore();

      if(!Object.prototype.hasOwnProperty.call(this.config, "products")) {
        return;
      }

      const config  = this.config;
      const header  = this.activeForm;
      const product = this.product;

      const data = config['products'].filter((curr) => curr['for'] === header);


      const item = data[0].list.filter((cur) => cur.value === product);

      if(!Object.prototype.hasOwnProperty.call(item[0], 'sub_products')){
        this.showSubProduct = false;
        return;
      }

      const items = [];

      item[0].sub_products.map((cur) => {
        items.push({'value': cur.value, 'label': cur.label});
      });

      // console.log('subProductLabel item[0]', item[0]);
      this.subProductLabel = item[0].sub_product_label;
      // console.log('subProductLabel', this.subProductLabel );


      this.subProductRef.setValue(items);

      //устанавливаем первый подпродукт, как выбранный
      const activeSubProduct = item[0].sub_products[0].value;

      this.subProductRef.setChoiceByValue(activeSubProduct);
      this.sub_product = activeSubProduct;

      this.showSubProduct = true;

    },

    setProductsList(newForm) {

      if(!Object.prototype.hasOwnProperty.call(this.config, "products")) {
        return;
      }

      //вычитываем продукты из конфига

      const config = this.config;
      // if(isProxy(config)) {
      //   config = toRaw(this.config);
      // }

      const data = config['products'].filter((curr) => curr['for'] === newForm);
      // console.log('data', data);

      if(!data.length) {
        return;
      }

      const products = [];

      let activeProduct = "";

      data.map((cur) => {

        if( (cur.activeProduct !== null) && (cur.activeProduct !== "") ) {
          activeProduct = cur.activeProduct;
        }

        cur.list.map((item) => {
          // products.push([item.value, item.label]);
          products.push( { value: item.value, label: item.label } );
        });

      });

      //очистить список продуктов
      this.productRef.clearStore();

      //заполнить новыми продуктами
      this.productRef.setValue(products);

      //устанавливаем выбранный продукт
      if( activeProduct !== "" ) {
        this.productRef.setChoiceByValue(activeProduct);
        this.product = activeProduct;
      }



    },

    setThankYouBlock(newForm) {

      // switch (this.activeForm) {
      //   case 'download':
      //   case 'download':
      //   case 'download':
      //
      // }
      // let thankYouBlock = '';
      // console.log('thankYouBlock', newForm, thankYouBlock);

      if(!Object.prototype.hasOwnProperty.call(this.config, "thankYouBlock")) {
        return;
      }

      const config = this.config;

      const data = config['thankYouBlock'].filter((curr) => curr['for'] === newForm);

      if( !data.length ) {
        return;
      }

      const html = data[0].html.replace(/\\"/g, "");
      // const html = data[0].html;
      // console.log('html', html);
      this.thankYouBlockContent = html;


    },

    menuItemClick(value, event) {

      if (event) {
        event.preventDefault();
      }

      this.activeForm = value;

    },

    // checkFileExtension({allowedExtension, event}) {
    //
    //   let name = ''
    //
    //   if(event.target.files.length) {
    //     name = event.target.files[0].name
    //   }
    //
    //   this.uploadFileName = name
    //   this.fileErrorObject = checkExtension({filename: name, allowedExtension})
    //
    // },


    async getFormConfig(url) {
      const response = await fetch(
          url,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
      );
      return response.json();
    },

    async initFunction() {
      await this.fillCountries(); //заполняем страны
      // await this.setPhonePlugin(); //подключаем плагин телефона

      this.getCookieDetail();
      // await this.getCookieDetail(); //получаем куки
    },

    async fillCountries() {
      // console.log('fillCountries');

      const data = await this.getCountryList();

      const arr = [];

      for (const item in data.countries) {
        arr.push({ value: item, label: item });
      }

      // this.countryRef.setValue(arr);

      if (data.detectedCountry !== "") {
        // this.countryRef.setChoiceByValue(data.detectedCountry);
        this.country = data.detectedCountry;
        this.detectedCountry = data.detectedCountry;
      }

      // this.countryShow = true; //включаем показ стран

      // console.log(this.detectedCountry)
      this.setPhonePlugin(); //подключаем плагин телефона


    },

    async getCountryList() {
      const response = await fetch(
          "https://www.starwindsoftware.com/v21-ajax-countries.js",
          {
            headers: {
              "Content-Type": "application/json",
            },
            // credentials: "same-origin"
          }
      );
      return response.json();
    },

    setPhonePlugin() {

      const detectedCountry = this.detectedCountry;
      // console.log('setPhonePlugin detectedCountry', detectedCountry)

      if (intlTelInput != null) {

        const me = this

        this.intlTelInputRef = intlTelInput(this.$refs.phoneRef, {
          utilsScript:
              "https://www.starwindsoftware.com/assets/libraries/intl-tel-input-17.0.19/build/js/utils.js",
          // utilsScript: loadUtils("build/js/utils.js"),
          preferredCountries: [],
          autoPlaceholder: "aggressive",
          separateDialCode: true,
          initialCountry: "auto",
          geoIpLookup: function(callback) {

            //help for geoIpLookup detail
            // https://github.com/jackocnr/intl-tel-input

            const formData = new URLSearchParams({ country: detectedCountry });
            fetch("https://www.starwindsoftware.com/geoip-detail.js",
                {
                  method: "POST",
                  headers: { "Content-Type": "application/x-www-form-urlencoded" },
                  body: formData,
                  // credentials: "same-origin",
                }
            )
            .then((res) => res.json())
            // .then((data) => callback(data.isoCode))
            .then((data) => {

              // console.log('data iso', data, data.isoCode)

              const code = (data.isoCode === '' || data.isoCode === undefined) ? 'US' : data.isoCode

              me.intlTelInputRef.setCountry(code)

              if ( data.captchaDraw !== undefined) {
                me.captchaDraw = data.captchaDraw
              }

              if ( data.encKeyString !== undefined) {
                me.encCaptchaValue = data.encKeyString
              }

              if ( data.sid !== undefined) {
                me.sid = data.sid
              }

            })
            .catch(() => callback("US"));

          }
        });


      }
    },

  }
};
</script>

<style scoped>
.countryShow {
  display: none;
}

.add-file-field-button{
  color: #0a4cb5;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  padding: 8px 20px;
  border: 1px solid #0a4cb5;
  display: block;
  cursor: pointer;
  transition: .2s;
  top: 0;
  bottom: 0;
  margin: auto 0;
  height: 40px;
  background-color: #ffffff;
}



</style>

<style>
.input-group {
  display: flex;
}
.captcha-image {
  background-color: #0A4CB5;
  width: 100%;
  max-width: 165px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-right: 20px;
}

.captcha-image:before {
  content: '';
  background-color: #0A3B89;
  position: absolute;
  height: 6px;
  left: 0;
  right: 0;
  bottom: 0;
}

.captcha-image div {
  height: 27px;
  width: 20px;
  float: left;
}

.captcha-input {
  width: 100%;
}

.captcha-input input::-webkit-outer-spin-button,
.captcha-input input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.captcha-input input[type=number] {
  -moz-appearance: textfield;
}
/* file */
.form-main .input-field input.input.hidden {
  display: none;
}

.input-file {
  color: #0A4CB5;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  padding: 8px 20px;
  border: 1px solid #0A4CB5;
  display: block;
  cursor: pointer;
  transition: .2s;
  position: absolute;
  height: 24px;
  top: 0;
  bottom: 0;
  margin: auto 0;
  right: 20px;
}

.input-file:hover {
  color: #0A3B89;
  border-color: #0A3B89;
}
/* /file */


.input-check-field {
  display: flex;
  margin-bottom: 22px;
}

.radio-field input[type=radio] {
  position: absolute;
  opacity: 0;
}

.radio-field input[type=radio] + .radio-label {
  position: relative;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 32px;
  cursor: pointer;
}

.radio-field input[type=radio] + .radio-label:before {
  content: "";
  background: #ffffff;
  border-radius: 100%;
  border: 0;
  box-shadow: inset 0 0 0 1px #0A4CB5;
  display: inline-block;
  width: 24px;
  height: 24px;
  position: relative;
  top: 4px;
  margin-right: 8px;
  vertical-align: top;
  cursor: pointer;
  text-align: center;
  transition: all .4s ease;
  box-sizing: border-box;
}
.radio-field input[type=radio]:checked + .radio-label:before {
  background-color: #ffffff;
  box-shadow: inset 0 0 0 7px #0A4CB5;
  border-color: transparent;
  border-width: 0;
}
.radio-field input[type=radio]:focus + .radio-label:before {
  outline: none;
  border-color: #3197EE;
}
.radio-field input[type=radio]:disabled + .radio-label:before {
  box-shadow: inset 0 0 0 4px #f4f4f4;
  border-color: #b4b4b4;
  background: #b4b4b4;
}
.radio-field input[type=radio] + .radio-label:empty:before {
  margin-right: 0;
}

.radio-field:not(:first-child) {
 margin-left: 60px;
}


@media screen and (max-width: 1919px) {
  .captcha-image {
    height: 56px;
  }

  .input-check-field {
    margin-bottom: 16px;
  }

  .radio-field input[type=radio] + .radio-label {
    font-size: 16px;
  }

  .radio-field input[type=radio] + .radio-label:before {
    top: 5px;
  }


}

@media screen and (max-width: 767px) {
  .captcha-image {
    max-width: 118px;
  }
}

@media screen and (max-width: 498px) {
  .input-check-field {
    display: flex;
    margin-bottom: 22px;
    flex-direction: column;
  }

  .radio-field:not(:first-child) {
    margin-left: 0;
    margin-top: 10px;
  }

}
</style>
